import Button from '~/App/Components/Button';
import styled from '@emotion/styled';

const ActionButton = styled(Button)`
  width: 100%;
  position: relative;
  line-height: 38px;
  padding: 0 !important;
  outline: none;

  &:focus {
    outline: none !important;
  }
`;

export default ActionButton;
